<!-- .block-banner -->
<div class="block block-banner">
    <div class="container">
        <a [routerLink]="url" class="block-banner__body">
            <img loading="lazy" style="max-width: 100%; height: auto;" [src]="img" [alt]="title"/>
        </a>
    </div>
</div>
<!-- .block-banner / end -->
